import { requiredParam } from 'sdc-utilities';

var baseUrl = 'index/';

export default (function (_ref) {
  var _ref$backend = _ref.backend,
      backend = _ref$backend === undefined ? requiredParam('backend') : _ref$backend;
  return {
    list: function list(_ref2) {
      var spaceID = _ref2.spaceID,
          parentType = _ref2.parentType,
          parentID = _ref2.parentID;
      return function () {
        return parentType && parentID ? backend.get(baseUrl + (spaceID + '?field=' + parentType + '&linkTo=' + parentID)) : backend.get(baseUrl + spaceID);
      };
    }
  };
});